export default __webpack_public_path__ + "static/media/addLanguageCircle.4df5bcfc.svg";